import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "./SignInForm";

export default function SignIn() {
  return (
    <>
      <PageMeta
        title="Sign In"
        description="Sign In to your account"
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
